import React from 'react'
import ProjectStatusManager from "../../../gd/manager/project-status-manager"

type Props = {
    className?  : string
    style?      : any

    size        : 26 | 22
    value       : any       // this is what being passed when we set on click or on delete !!!

    // Special cases
    statusId    : string | number,     // if passes - display icon & label automatically

    // callbacks
    onClick     : func
    onDelete?   : func       // if set adds delete button
}

// const debug = "PillStatus"
const debug = false

export default function PillStatus(props: Props) {

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onDelete) props.onDelete(props.value)
    }

    let status = gd.session.statuses.get(props.statusId)

    // search for default status for Folders
    if (!status) {
        const defaultStatuses = ProjectStatusManager.getDefaultStatuses()
        status = _.find(defaultStatuses, (defaultStatus: any) => {
            return defaultStatus.id === props.statusId
        })

        debug && console.log(debug, 'render defaultStatuses', defaultStatuses)
    }

    debug && console.log(debug, 'render', status, props.statusId, props.value)

    const classes = Classes('ui5-pill-u pale', 'bg-status-paleBg-'+status.color, 'ui5-txt-status-'+status.color, 's-'+props.size, props.className)

    const showDelete = !!props.onDelete

    return (
        <div className={classes} onClick={onClick}>
            <div className="pill-label">{status.name}</div>
            {showDelete &&
                <div className="i5-close" onClick={onDelete}/>
            }
        </div>
    )
}

PillStatus.defaultProps = {
    size: 26
}
